module.exports = __webpack_public_path__ + "static/thumb-9-e9f5b1ba23981bb6876aeb18a77ade5d.jpg";